import {
  merge, reject, propEq, insert, findIndex
} from 'ramda';
import {
  LOAD_REQUEST,
  LOAD_FAIL,
  LOAD_SUCCESS,
  LOAD_OPTIONS_SUCCESS,
  SUBMIT_FAIL,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
  DELETE_SUCCESS
} from 'src/store/actions/formFilterActions';

const initialState = {
  list: [],
  fetching: false,
  errors: []
};

const addOrReplaceInList = (filter, prop, list) => (
  insert(findIndex(propEq(prop, filter[prop]), list), filter, reject(propEq(prop, filter[prop]), list)));

export const filterToOption = ({ Id, Name }) => ({
  value: Id,
  label: Name
});

const formFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REQUEST:
      return merge(state, { fetching: true, list: [] });
    case LOAD_SUCCESS:
      return merge(state, { list: action.filters, fetching: false, errors: [] });
    case LOAD_OPTIONS_SUCCESS:
      return merge(state, { options: action.options });
    case LOAD_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true });
    case SUBMIT_SUCCESS:
      return merge(state, {
        fetching: false,
        errors: [],
        list: addOrReplaceInList(action.result.Data, 'Id', state.list)
      });
    case SUBMIT_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case DELETE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('Id', action.filterId), state.list)
        // options: reject(propEq('value', action.filterId), state.options)
      });
    default:
      return state;
  }
};

export default formFilterReducer;
